import { Divider, Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import mappingStyles from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import style from "../../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import Required from '../../../utility/required';
import GlobalTooltip from '../../../utility/tooltip/globalTooltip';
import IconsColor from '../../../utility/iconsColor';
import { primaryColor } from '../../../../utils/colors';
import FileUpload from '../../../utility/fileUpload/fileUpload';
import { getFileTypeImgIcon, getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from '../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import axios from 'axios';
import GlobalButton from '../../../utility/globalButton/button';
import { createKnowledgeBaseFilesPayload } from '../../../../models/axiosModel';
import agent from '../../../../services/api';
import { useKnowledgeBaseStore } from '../../../../store/knowledgeBaseStore';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { getVendorField } from '../../../../utils/whiteLabelling';

interface UploadKnowledgeBaseFilePopupProps {
    getKnowledgeBaseFilesApiCall: () => Promise<void>,
} 

const UploadKnowledgeBaseFilePopup: React.FC<UploadKnowledgeBaseFilePopupProps> = (props) => {
    
    const { getKnowledgeBaseFilesApiCall } = props; 
    const { setFlagLoading, flagLoading, handleError, vendorData } = useContext(UserContext) as UserContextPayload; 
    const setFlagUploadKnowledgeBaseFilePopup = useKnowledgeBaseStore((state) => state.setFlagUploadKnowledgeBaseFilePopup);  

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const innerHeight = window.innerHeight - 130; 

    const [files, setFiles] = useState<any>([]); 
    const [progress, setProgress] = useState({ filename: "", percent: 0 });
    

    const uploadFileHandler = async (e: any) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setFiles((prev: any) => {
                return [...prev, file];
            })

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }
            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
                await axios.post(`${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/storage/file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true,
                onUploadProgress: config.onUploadProgress,
            }).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                // rr.page_field_id = id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })

                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                console.error(err)
            });
            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }
        
    const removeFileHandler = async (id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await axios.delete(`${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/storage/file?file_id=${id}`, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
        }).then(async (res) => {
            if (res.data.status) {
                setFiles((prev: any) => {
                    return prev?.filter((file: any) => file?.google_storage_id != id);
                })
                showSuccess("File Deleted Successfully")
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
    } 

    const checkDisableUploadButton = () => {
        if(files?.length == 0){
            return true;
        } 
        return false;
    } 

    const handleUploadFiles = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: createKnowledgeBaseFilesPayload = {
            knowledgebase_file: files?.map((file: any) => {
                return {
                    google_storage_id: file?.google_storage_id, 
                    flag_extraction_required: false, 
                    extracted_google_storage_id: null,
                }
            })
        } 

        const res = await agent.createKnowledgeBaseFile.post(payload);
        if(!(res.status)) {
            handleError(res);
        } else {
            getKnowledgeBaseFilesApiCall(); 
            showSuccess(`${res?.data?.length - res?.error?.length} file${res?.data?.length - res?.error?.length === 1 ? '' : 's'} uploaded successfully.`)
        } 
        setFlagUploadKnowledgeBaseFilePopup(false);
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }
    
    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={mappingStyles.popupTitleTypography}>Upload Knowledge Base File</Typography>
                        </Grid>

                        <Divider className={mappingStyles.popupTitleDivider} /> 

                        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`} sx={{maxHeight: `${innerHeight}px !important`}}>
                            <Grid container className={mappingStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container className={`${globalStyles.flexColumn}`} gap={1}>
                                        <Grid item>
                                            <Typography className={mappingStyles.popupFieldTypography}>Knowledge Base <Required />
                                                <GlobalTooltip
                                                    arrow
                                                    placement='bottom'
                                                    title={`Allowed File Formats (.doc, .docx, .json, .md, .pdf, .pptx, .txt)`}
                                                >
                                                    <span style={{ cursor: "pointer", verticalAlign: "middle", marginLeft: "8px", marginTop: "3px" }} >
                                                        <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                                    </span>
                                                </GlobalTooltip>
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <FileUpload
                                                uploadedFileDetails={files}
                                                multipleFileAllow={true}
                                                fileSizeAllowed={5}
                                                fileTypeAllowed={`.doc, .docx, .json, .md, .pdf, .pptx, .txt`}
                                                fileNumberAllowed={5}
                                                uploadFileHandler={(e) => uploadFileHandler(e)}
                                                removeFileHandler={(id) => removeFileHandler(id)}
                                                isDisabled={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='borderedButtonStyle'
                                                onClick={() => setFlagUploadKnowledgeBaseFilePopup(false)}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Upload"
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='primaryButtonStyle' 
                                                disabled={checkDisableUploadButton()}
                                                onClick={() => handleUploadFiles()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default UploadKnowledgeBaseFilePopup
